import { render, staticRenderFns } from "./intimacy_log.vue?vue&type=template&id=4cc5132b"
import script from "./intimacy_log.vue?vue&type=script&lang=ts"
export * from "./intimacy_log.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports